import { render, staticRenderFns } from "./PropBaseShareSentiment.vue?vue&type=template&id=ab58faca&"
import script from "./PropBaseShareSentiment.vue?vue&type=script&lang=js&"
export * from "./PropBaseShareSentiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports